import { ActionTypes } from "store/constants";

export const openChat = (returnedPayload) => ({ type: ActionTypes.chat.openChat, payload: returnedPayload });